import type { FormInputType } from '@/components/UI/Form/types'

export default function getTutorTrainingAssignmentFormInputs(
  tutorTrainings: { slug: string; title: string }[]
): FormInputType[] {
  const formInputs: FormInputType[] = [
    {
      label: 'Select a training',
      type: 'multi-select',
      sublabel:
        'You may assign multiple trainings by resubmitting this form. Trainings modules that the tutor has not yet completed are listed.',
      name: 'trainings',
      options: tutorTrainings.map(item => ({
        value: item.slug,
        label: item.title,
      })),
      required: true,
      size: 6,
    },
    {
      label: 'Provide a reason (this will be shared with the tutor)*',
      type: 'textarea',
      name: 'reason',
      required: true,
      size: 6,
    },
    {
      type: 'multi-checkbox',
      name: 'priority',
      label: 'Priority',
      options: [
        {
          value: 'required',
          label:
            'Prevent this tutor from creating any new sessions or series until they complete this training.',
        },
      ],
      required: false,
      size: 6,
    },
  ]

  return formInputs
}
